var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("custom-tooltip-container", {
        attrs: { "open-by-default": true },
        scopedSlots: _vm._u([
          {
            key: "tooltipTarget",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "ob1-link-icon ps-1",
                    attrs: { "data-testid": "cart-recovery-tooltip-target" },
                  },
                  [
                    _c("span", {
                      staticClass: "icon",
                      class: _vm.icon,
                      staticStyle: { "font-size": "40px" },
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _vm.showBadge
                      ? _c("span", {
                          staticClass:
                            "ob1-badge ob1-badge-negative ob1-badge-large",
                          staticStyle: {
                            "margin-left": "-10px",
                            "margin-top": "-40px",
                          },
                          domProps: { textContent: _vm._s(_vm.badgeValue) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showBadge
                      ? _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v("articles dans votre panier"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tooltipContent",
            fn: function () {
              return [
                _c(
                  "div",
                  { attrs: { "data-testid": "cart-recovery-tooltip-content" } },
                  [
                    _c("div", { staticClass: "d-flex flex-column p-1" }, [
                      _c("strong", {
                        staticClass: "mb-2 font-size-16",
                        domProps: { textContent: _vm._s(_vm.tooltip.title) },
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "mb-2",
                        domProps: { textContent: _vm._s(_vm.tooltip.content) },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("generic-button-cta", {
                            attrs: {
                              "dto-from-object": _vm.tooltip.cta,
                              "css-classes":
                                "btn-primary px-1 px-md-2 mt-1 mt-lg-0",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }